import Widget from '../../api/widget'

export default {
  namespaced: true,
  state: {
    button: {
    },
    activeNav: {
    }
  },
  mutations: {
    setStyles (state, styles) {
      state.button = {...styles.button}
      state.activeNav = {...styles.activeNav}
    }
  },
  actions: {
    async getWidgetStyles ({commit}, jobBoardId) {
      try {
        const styles = await Widget.getWidgetStyles(jobBoardId)
        commit('setStyles', {
          button: {
            backgroundColor: styles.buttonBackgroundColor
          },
          activeNav: {
            borderBottom: styles.activeNavBorderBottom.includes('solid') ? styles.activeNavBorderBottom : `2px solid ${styles.activeNavBorderBottom}`
          }
        })
      } catch (e) {
        console.log('error', e)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/widget-styles.js